import * as API from '@/services/API';

export default {
  get(id) {
    return API.apiClient.get(`/group-types/${id}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/group-types/${query}`);
  },
  async delete(id) {
    return API.apiClient.delete(`/group-types/${id}`);
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/group-types`, data);
    } else {
      return API.apiClient.put(`/group-types/${id}`, data);
    }
  },
  search(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/group-types/search${query}`);
  }
};
